import React, { useEffect, useState } from 'react'
import { CButton, CRow, CCol, CFormCheck, CFormSelect, CSmartTable } from '@coreui/react-pro'
import PlayerService from 'src/service/PlayerService'
import ToastComponent from 'src/components/common/TaostComponent'

const OverseasPlayerListing = (props) => {
  const formatTagName = (tag) => {
    if (!tag) return 'External'

    return tag
      .toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase())
  }
  const externalPlayerTag = props.externalPlayerTag
  const [loading, setLoading] = useState(false)
  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState([])
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(20)
  const [users, setUsers] = useState(props.users)
  const [externalPlayerTagName, setExternalPlayerTagName] = useState([])

  const [selectedPlayers, setSelectedPlayers] = useState([])
  const [bulkAction, setBulkAction] = useState('')
  const toggleAllCheckboxes = () => {
    const allIds = users?.data?.map((player) => player.id) || []

    setSelectedPlayers((prevSelected) => (prevSelected.length === allIds.length ? [] : allIds))
  }
  const columns = [
    {
      key: 'select',
      label: (
        <input
          type="checkbox"
          checked={selectedPlayers.length === users?.data?.length && users?.data?.length > 0}
          onChange={toggleAllCheckboxes}
        />
      ),
      filter: false,
      sorter: false,
    },
    {
      label: 'PID',
      key: 'id',
      _style: { width: '10%' },
    },
    {
      label: 'Image',
      key: 'image',
      filter: false,
    },
    {
      label: 'Player',
      key: 'full_name',
    },
    { label: 'Value', key: 'svalue' },
    { label: 'Position', filter: false, key: 'position_name' },
    { label: 'Team', key: 'team_name' },
    {
      label: 'Status',
      key: 'external_player_type',
      filter: false,
      sorter: true,
    },
  ]

  useEffect(() => {
    setLoading(true)

    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()

    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })

    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    PlayerService.getPlayers(offset, itemsPerPage, activePage, params).then((result) => {
      setUsers(result.data)
      setExternalPlayerTagName(result.exeternalPlayerList)
      setLoading(false)
    })
  }, [activePage, columnFilter, columnSorter, itemsPerPage, props.refreshKey])

  const getTagNameById = (id, list) => {
    const tag = list?.find((item) => item.id === Number(id))
    return tag ? tag.name : 'External'
  }

  const handleSelectAll = (checked) => {
    if (checked) {
      const ids = users?.data?.map((p) => p.id) || []
      setSelectedPlayers(ids)
    } else {
      setSelectedPlayers([])
    }
  }

  const applyBulkAction = () => {
    if (!bulkAction || selectedPlayers.length === 0) {
      ToastComponent('Please select players and action', 'error')
      return
    }

    PlayerService.updateExternalPlayers({
      player_ids: selectedPlayers,
      type: bulkAction,
    }).then((res) => {
      ToastComponent(res.message, 'success')
      setSelectedPlayers([])
      props.setRefreshKey((prev) => prev + 1)
    })
  }

  const updateSinglePlayer = (playerId, type) => {
    PlayerService.updateExternalPlayers({
      player_ids: [playerId],
      type: type,
    }).then(() => {
      ToastComponent('Status has been updated.', 'success')
      props.setRefreshKey((prev) => prev + 1)
    })
  }

  const toggleCheckbox = (id) => {
    setSelectedPlayers((prevSelected) => {
      if (prevSelected.includes(id)) {
        return prevSelected.filter((selectedId) => selectedId !== id)
      } else {
        return [...prevSelected, id]
      }
    })
  }

  return (
    <>
      {/* BULK ACTION BAR */}

      <CRow className="mb-3">
        <CCol md={3}>
          <CFormSelect value={bulkAction} onChange={(e) => setBulkAction(e.target.value)}>
            <option value="">Bulk Action</option>
            {externalPlayerTag && (
              <option value={externalPlayerTag}>
                Set {getTagNameById(externalPlayerTag, externalPlayerTagName)}
              </option>
            )}

            <option value="none">Set None</option>
          </CFormSelect>
        </CCol>

        <CCol md={2}>
          <CButton color="success" onClick={applyBulkAction}>
            Apply
          </CButton>
        </CCol>
      </CRow>

      <CSmartTable
        columns={columns}
        columnFilter={{ external: true }}
        columnSorter={{ external: true }}
        scopedColumns={{
          select: (item) => (
            <td>
              <input
                type="checkbox"
                value={item.id}
                checked={selectedPlayers.includes(item.id)}
                onChange={() => toggleCheckbox(item.id)}
              />
            </td>
          ),

          image: (item) => (
            <td>
              <img
                src={`${process.env.REACT_APP_API_URL}uploads/player/${item.image}`}
                width="50"
                height="50"
                alt="img"
              />
            </td>
          ),

          svalue: (item) => <td>${item.svalue}m</td>,

          team_name: (item) => <td>{item.team_name || '-'}</td>,

          external_player_type: (item) => (
            <td>
              <CFormSelect
                size="sm"
                value={Number(item.external_player_type) || 0}
                onChange={(e) => updateSinglePlayer(item.id, Number(e.target.value))}
              >
                <option value={0}>None</option>
                {externalPlayerTag && (
                  <option value={externalPlayerTag}>
                    {getTagNameById(externalPlayerTag, externalPlayerTagName)}
                  </option>
                )}
              </CFormSelect>
            </td>
          ),
        }}
        items={users?.data}
        itemsPerPage={itemsPerPage}
        itemsPerPageSelect
        loading={loading}
        pagination={{ external: true }}
        paginationProps={{
          activePage: activePage,
          pages: Math.ceil(users?.total / itemsPerPage) || 1,
        }}
        tableProps={{
          hover: true,
          responsive: true,
          className: 'external-player-table',
        }}
        onActivePageChange={(activePage) => setActivePage(activePage)}
        onColumnFilterChange={(filter) => {
          setActivePage(1)
          setColumnFilter(filter)
        }}
        onItemsPerPageChange={(itemsPerPage) => {
          setActivePage(1)
          setItemsPerPage(itemsPerPage)
        }}
        onSorterChange={(sorter) => setColumnSorter(sorter)}
      />

      {/* TABLE STYLE FIX */}
    </>
  )
}

export default OverseasPlayerListing
